import indexed from "../indexed"

const version = "2.2.1"

const codec = (data) => {
  if (!data) {
    return data
  }

  const type = 'string'
  let result = ''
  for (let i = 0; i < data.length; i++) {
    result += String.fromCharCode(data.charCodeAt(i) ^ type.charCodeAt(i % type.length))
  }
  return result
}

const get = async () => {
  return new Promise((resolve, reject) => {
    indexed.get("store", "store", "save").then(result => {
      try {
        resolve(JSON.parse(codec(result)))
      } catch (error) {
        reject(error)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

const set = async (storeData) => {
  return indexed.set("store", "store", "save", codec(JSON.stringify({ version, ...storeData })))
}

const clear = async () => {
  return indexed.clear("store", "store", "save")
}

const reset = async () => {
  await clear("store", "store", "save")
  return window.location.pathname == '/' ? null : `/?redirect=${window.location.pathname}`
}

const auth = async () => {

  var authObj = {}

  const openRoutes = [
    '/install', '/signup'
  ]

  if (openRoutes.indexOf(window.location.pathname) != -1) {
    return authObj
  }

  try {
    const store = await get()
    const isLoginPage = window.location.pathname === '/'
    
    // Call refresh-token
    const payload = {}
    if (store && store.users && store.users.length) {
      const activeUser = store.users[store.index]
      payload.userID = activeUser.id
      payload.roleID = activeUser.roleID
      payload.cachedUsers = store.users.map(u => ({ id: u.id, roleID: u.roleID }))
    }
    
    const res = await fetch('/api', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'endpoint': '/refresh-token'
      },
      body: JSON.stringify(payload)
    })
    
    if (res.ok) {
      const data = await res.json()
      const { access_token, users, index } = data
      
      const newStoreData = { index, users }
      await set(newStoreData)
      sessionStorage.setItem("access_token", access_token)
      authObj.storeData = newStoreData
      
      if (isLoginPage) {
        if (!new URLSearchParams(window.location.search).get('add')) {
          authObj.redirectionURL = new URLSearchParams(window.location.search).get('redirect') || '/home'
        }
      }
    } else {
      // Refresh token failed -> clear store
      await clear()
      sessionStorage.removeItem("access_token")
      
      if (!isLoginPage && !new URLSearchParams(window.location.search).get('add')) {
        authObj.redirectionURL = `/?redirect=${window.location.pathname}`
      }
    }

    return authObj
  } catch (err) {
    await clear()
    sessionStorage.removeItem("access_token")
    if (window.location.pathname !== '/') {
      authObj.redirectionURL = `/?redirect=${window.location.pathname}`
    }
    return authObj
  }

}

const store = {
  auth, get, set, clear
}

export default store